import { render, staticRenderFns } from "./TaxA.vue?vue&type=template&id=a67e0a6a&"
import script from "./TaxA.vue?vue&type=script&lang=js&"
export * from "./TaxA.vue?vue&type=script&lang=js&"
import style0 from "./TaxA.vue?vue&type=style&index=0&id=a67e0a6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports